export default function(loop) {
  return new Array(loop).fill(undefined).map((x, i) => i);
}
